import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class SetupServiceAccountStep extends React.Component {
  constructor() {
    super();
    this.state = {
      userAgreed: false,
    };
  }

  handleUserAgreementCheck = (event) => {
    this.setState({
      userAgreed: event.target.checked,
    });
  };

  handleCreateAccountClick = async () => {
    await this.props.actions.createServiceAccount();
    this.props.actions.notifySuccess(
      I18n.t('firstTimeSetup.serviceAccount.form.feedback.success'),
    );

    this.props.onNextStep();
  };

  handleGoToLibraryClick = async () => {
    if (!this.isServiceAccountCreated()) {
      await this.props.actions.skipServiceAccount();
    }

    this.props.onNextStep();
  };

  canCreateServiceAccount() {
    const { creating, skipping } = this.props;
    const { userAgreed } = this.state;

    if (creating || skipping) {
      return false;
    }

    if (!userAgreed) {
      return false;
    }

    if (this.isServiceAccountCreated()) {
      return false;
    }

    return true;
  }

  canGoToLibrary() {
    const { userAgreed } = this.state;
    const { creating, skipping } = this.props;

    if (userAgreed) {
      return this.isServiceAccountCreated();
    }

    if (creating || skipping) {
      return false;
    }

    return true;
  }

  isServiceAccountCreated() {
    return this.props.success;
  }

  renderUserFeedback() {
    const { error, skipError } = this.props;

    if (error) {
      return (
        <div className="feedback-addin feedback-addin-failure">
          <Icon>warning</Icon>
          <Translate value="firstTimeSetup.serviceAccount.form.feedback.failure" />
        </div>
      );
    }

    if (skipError) {
      return (
        <div className="feedback-addin feedback-addin-failure">
          <Icon>warning</Icon>
          <Translate value="firstTimeSetup.serviceAccount.form.feedback.skipFailure" />
        </div>
      );
    }

    return null;
  }

  render() {
    const { creating, skipping } = this.props;
    const { userAgreed } = this.state;

    return (
      <>
        <Typography variant="h2" className="title__center" gutterBottom>
          <Translate value="firstTimeSetup.serviceAccount.title" />
        </Typography>

        <Typography className="title__center margin__bottom">
          <Translate value="firstTimeSetup.serviceAccount.message" />
        </Typography>

        <div className="firsttimesetup__field">
          <FormControlLabel
            control={(
              <Checkbox
                color="primary"
                disabled={creating || this.isServiceAccountCreated()}
                checked={userAgreed}
                onChange={this.handleUserAgreementCheck}
              />
            )}
            label={I18n.t(
              'firstTimeSetup.serviceAccount.form.agreementCheckboxMessage',
            )}
          />
        </div>

        <div className="firsttimesetup__button-cont dvrtoolkitbutton">
          <Button
            variant="contained"
            color="primary"
            className="btn btn-primary"
            disabled={!this.canCreateServiceAccount()}
            onClick={this.handleCreateAccountClick}
          >
            {!creating && (
              <Translate value="firstTimeSetup.serviceAccount.form.createAccountButton" />
            )}

            {creating && (
              <CircularProgress
                className="loading__cirgularprogress"
                size={25}
              />
            )}
          </Button>
        </div>

        <div className="firsttimesetup__button-cont dvrtoolkitbutton">
          <Button
            variant="outlined"
            color="primary"
            disabled={!this.canGoToLibrary()}
            onClick={this.handleGoToLibraryClick}
          >
            {!skipping && (
              <Translate value="firstTimeSetup.serviceAccount.form.skipToLibraryButton" />
            )}

            {skipping && (
              <CircularProgress
                className="loading__cirgularprogress"
                size={25}
              />
            )}
          </Button>
        </div>

        {this.renderUserFeedback()}
      </>
    );
  }
}

SetupServiceAccountStep.propTypes = {
  creating: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.bool,
  skipping: PropTypes.bool,
  onNextStep: PropTypes.func,
  actions: PropTypes.shape({
    createServiceAccount: PropTypes.func,
    skipServiceAccount: PropTypes.func,
    notifySuccess: PropTypes.func,
  }),
  skipError: PropTypes.bool,
};

SetupServiceAccountStep.defaultProps = {
  creating: false,
  success: false,
  error: false,
  skipping: false,
  onNextStep: () => {},
  actions: {
    createServiceAccount: () => {},
    skipServiceAccount: () => {},
    notifySuccess: () => {},
  },
  skipError: false,
};
